import { Box, Chip, Typography } from "@mui/material";
import { ErrorMessage, FormDropdownFilter } from "components";
import { Control, useWatch } from "react-hook-form";
import * as labels from "./constants";

interface plantsDropdownProps {
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	control: Control<any>;
	containmentTypeApiName?: string;
	watchedSectors?: any[];
	plantFilterType?: any;
	availablePlants?: any[];
	getImpactedPlantOptionDisabled?: (plant: any) => boolean;
	onPlantChange?: (args: { field: any; value: any }) => void;
	plantValidationRules?: any;
}

export function PlantsDropdown({
	control,
	containmentTypeApiName,
	watchedSectors = [],
	plantFilterType,
	availablePlants = [],
	getImpactedPlantOptionDisabled,
	onPlantChange,
	plantValidationRules,
}: plantsDropdownProps): React.JSX.Element {
	const selectedPlants = useWatch({ control, name: "plants" }) || [];
	const selectedPlantCount = Array.isArray(selectedPlants)
		? selectedPlants.length
		: 0;
	return (
		<Box data-test-selector="plants-dropdown">
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
				<Typography sx={{ fontWeight: 600, fontSize: "0.8rem" }}>
					{labels.Plants}
				</Typography>
				{selectedPlantCount > 0 && (
					<Chip
						label={selectedPlantCount}
						size="small"
						color="primary"
						sx={{
							height: 20,
							minWidth: 20,
							"& .MuiChip-label": { px: 0.5, fontSize: "0.72rem", fontWeight: 600 },
						}}
					/>
				)}
			</Box>
			<FormDropdownFilter
				key={`plants-${containmentTypeApiName}-${watchedSectors.map((s: any) => s.id).join("-")}`}
				control={control}
				name="plants"
				multiple
				filterType={plantFilterType}
				disabled={availablePlants.length === 0}
				staticOptions={availablePlants}
				keyFunc={(impactedPlant: any) => impactedPlant.id}
				labelFunc={(impactedPlant: any) => impactedPlant.name}
				groupBy={(impactedPlant: any) => impactedPlant.sectorContext || "Other"}
				getOptionDisabled={(impactedPlant: any) =>
					getImpactedPlantOptionDisabled?.(impactedPlant) ?? false
				}
				onChange={onPlantChange}
				rules={plantValidationRules}
				renderError={(err: any) =>
					err.IfErr((msg: string) => <ErrorMessage msg={msg} />).UnwrapOrNil()
				}
			/>
		</Box>
	);
}
